import { html } from 'lit';
export const landCategoryUrlParams = [
    'wanderlandetappennational',
    'wanderlandetappenregional',
    'wanderlandetappenlokal',
    'wanderlandetappenhandicap',
    'wanderwegnetz',
    'velolandetappennational',
    'velolandetappenregional',
    'velolandetappenlokal',
    'mtblandetappennational',
    'mtblandetappenregional',
    'mtblandetappenlokal',
    'mtblandtrails',
    'skatinglandetappennational',
    'skatinglandetappenregional',
    'skatinglandetappenlokal',
    'kanulandetappennational',
    'kanulandetappenregional',
    'crosscountryetappenlokal',
    'crosscountrynetwork',
    'winterhikingnetwork',
    'winterhikingetappenlokal',
    'snowshoenetwork',
    'snowshoeetappenlokal',
    'velonetwork',
    'mtbnetwork',
    'skatenetwork',
    'velonetwork_surface',
    'mtbnetwork_surface',
    'skatenetwork_surface',
    'velonetwork_grade',
    'mtbnetwork_grade',
    'skatenetwork_grade',
];
export const LAND_CATEGORIES = {
    wanderland: [
        'WanderlandEtappenNational',
        'WanderlandEtappenRegional',
        'WanderlandEtappenLokal',
        'WanderlandEtappenHandicap',
        'Wanderwegnetz',
    ],
    veloland: [
        'VelolandEtappenNational',
        'VelolandEtappenRegional',
        'VelolandEtappenLokal',
    ],
    mtbland: [
        'MtblandEtappenNational',
        'MtblandEtappenRegional',
        'MtblandEtappenLokal',
        'MtblandTrails',
    ],
    skatingland: [
        'SkatinglandEtappenNational',
        'SkatinglandEtappenRegional',
        'SkatinglandEtappenLokal',
    ],
    kanuland: ['KanulandEtappenNational', 'KanulandEtappenRegional'],
    crosscountry: ['CrosscountryEtappenLokal', 'CrosscountryNetwork'],
    snowshoe: ['SnowshoeEtappenLokal', 'SnowshoeNetwork'],
    winterhiking: ['WinterhikingEtappenLokal', 'WinterhikingNetwork'],
};
export const summerLandLayers = [
    'wanderland',
    'veloland',
    'mtbland',
    'skatingland',
    'kanuland',
];
export const winterLandLayers = [
    'winterhiking',
    'snowshoe',
    'crosscountry',
    'sledging',
];
export const multiLandLayers = [
    ...summerLandLayers,
    'crosscountry',
    'winterhiking',
    'snowshoe',
];
export const summerNetworkLayers = [
    'wanderwegnetz',
    'velonetwork',
    'mtbnetwork',
    'skatenetwork',
];
export const activityNetworkLayers = [
    'velonetwork',
    'mtbnetwork',
    'skatenetwork',
];
export const summerLandCodes = [
    'hike',
    'cycle',
    'mountainbike',
    'skate',
    'canoe',
];
export const winterLandCodes = [
    'crosscountry',
    'winterhike',
    'snowshoe',
    'sledge',
];
export const landCodeToActivity = {
    hike: 'wander',
    cycle: 'velo',
    mountainbike: 'mountain_biking',
    skate: 'skating',
    canoe: 'canoeing',
    crosscountry: 'cross_country_skiing',
    winterhike: 'winter_hiking',
    snowshoe: 'snowshoe_trekking',
    sledge: 'sledging',
};
export const alternativeLandCodes = ['mountainbikeland', 'mtb'];
export const legacyLandCodes = [
    'wander',
    'velo',
    'mountainbike',
    'skating',
    'kanu',
    'winterhiking',
    'snowshoe',
    'crosscountry',
    'sledging',
];
export const POILayersInfo = [
    {
        title: () => `Trasporti pubblici`,
        icon: 'bg-[url("./src/img/i_transport.svg")]',
        winter: true,
        summer: true,
        code: 'station',
    },
    {
        title: () => `Alloggio`,
        icon: 'bg-[url("./src/img/i_accommodation.svg")]',
        winter: true,
        summer: true,
        code: 'accommodation',
    },
    {
        title: () => `Localit\u00E0`,
        icon: 'bg-[url("./src/img/i_places.svg")]',
        winter: true,
        summer: true,
        code: 'place',
    },
    {
        title: () => `Curiosit\u00E0`,
        icon: 'bg-[url("./src/img/i_sightseeing.svg")]',
        winter: true,
        summer: true,
        code: 'sightseeing',
    },
    {
        title: () => `Noleggio bici ed e-bike`,
        icon: 'bg-[url("./src/img/i_bicycle.svg")]',
        winter: false,
        summer: true,
        code: 'velorental',
    },
    {
        title: () => `Assistenza bici`,
        icon: 'bg-[url("./src/img/i_service.svg")]',
        winter: false,
        summer: true,
        code: 'cycleservice',
    },
    {
        title: () => `Parchi svizzeri`,
        icon: 'bg-[url("./src/img/i_swissparks.svg")]',
        winter: true,
        summer: true,
        code: 'swisspark',
    },
    {
        title: () => `Cani da guardiania`,
        icon: 'bg-[url("./src/img/i_alpguarddogs.svg")]',
        winter: false,
        summer: true,
        code: 'alpguarddog',
    },
    {
        title: () => `Zone di tranquillit\u00E0`,
        icon: 'bg-[url("./src/img/i_wildlife.svg")]',
        winter: true,
        summer: false,
        code: 'wildlife',
    },
    {
        title: () => `Pendenza maggiori 30\u00B0`,
        icon: 'bg-[url("./src/img/i_slope.svg")]',
        winter: true,
        summer: true,
        code: 'slope',
    },
    {
        title: () => `Altezza della neve`,
        icon: 'bg-[url("./src/img/i_snowdepth.svg")]',
        winter: true,
        summer: true,
        code: 'snowdepth',
    },
].filter((v) => v);
export const HiddenLayersInfo = [
    { title: () => `slowUp`, winter: true, summer: true, code: 'slowup' },
    {
        title: () => `Comuni`,
        winter: true,
        summer: true,
        code: 'municipalities',
    },
    { title: () => `Cantoni`, winter: true, summer: true, code: 'cantons' },
];
export const baseLayerCodes = ['pk', 'pkg', 'lb'];
export const BackgroundLayersInfo = [
    {
        title: () => `Mappa a colori`,
        icon: 'bg-[url("./src/img/i_map_color.svg")]',
        code: 'pk',
    },
    {
        title: () => `Mappa in grigio`,
        icon: 'bg-[url("./src/img/i_map_grey.svg")]',
        code: 'pkg',
    },
    {
        title: () => `Foto area`,
        icon: 'bg-[url("./src/img/i_map_aerial.svg")]',
        code: 'lb',
    },
];
export const AdditionalRouteLayersInfo = [
    {
        title: () => `Numeri dei percorsi`,
        icon: 'bg-[url("./src/img/i_route_nr.svg")]',
        code: 'logos',
    },
    {
        title: () => `Foto`,
        icon: 'bg-[url("./src/img/i_photos.svg")]',
        code: 'photos',
    },
    {
        title: () => `Chiusura / Deviazione`,
        icon: 'bg-[url("./src/img/i_detour.svg")]',
        codes: ['detours', 'shooting'],
    },
];
export const routeCategoryCodes = [
    'national',
    'regional',
    'local',
    'handicap',
    'trails',
];
const winterCategories = ['local'];
const nationalRegional = ['national', 'regional'];
const nationalRegionalLocal = [
    ...nationalRegional,
    'local',
];
const nationalRegionalLocalTrails = [
    ...nationalRegionalLocal,
    'trails',
];
export const ROUTE_LAYERS = {
    hike: {
        legacyLandCode: 'wander',
        logoFilename: 'logos_wander_segment.geojson',
        season: 'summer',
        colorClass: 'bg-hike',
        pageColorClass: 'bg-page-hike',
        logoClass: 'bg-[url("./src/img/logo_wl.svg")]',
        landCode: 'hike',
        layer: 'wanderland',
        getTitle: () => html `La\u00A0Svizzera<br>a\u00A0piedi`,
        getTitleNoHyphen: () => html `La\u00A0Svizzera<br>a\u00A0piedi`,
        getFlatTitle: () => `La Svizzera a piedi`,
        getLayerHintTitle: () => `Percorsi di La Svizzera a piedi`,
        categories: [...nationalRegionalLocal, 'handicap'],
        colorRGB: '#609E26',
    },
    cycle: {
        legacyLandCode: 'velo',
        logoFilename: 'logos_velo_segment.geojson',
        season: 'summer',
        colorClass: 'bg-cycle',
        pageColorClass: 'bg-page-cycle',
        logoClass: 'bg-[url("./src/img/logo_vl.svg")]',
        landCode: 'cycle',
        layer: 'veloland',
        getTitle: () => html `La\u00A0Svizzera<br>in\u00A0bici`,
        getTitleNoHyphen: () => html `La\u00A0Svizzera<br>in\u00A0bici`,
        getFlatTitle: () => `La Svizzera in bici`,
        getLayerHintTitle: () => `Percorsi di La Svizzera in bici`,
        categories: nationalRegionalLocal,
        colorRGB: '#5C94CF',
    },
    mountainbike: {
        legacyLandCode: 'mountainbike',
        logoFilename: 'logos_mountainbike_segment.geojson',
        season: 'summer',
        colorClass: 'bg-mountainbike',
        pageColorClass: 'bg-page-mountainbike',
        logoClass: 'bg-[url("./src/img/logo_ml.svg")]',
        landCode: 'mountainbike',
        layer: 'mtbland',
        getTitle: () => html `La\u00A0Svizzera<br>in mountain\u00A0bike`,
        getTitleNoHyphen: () => html `La\u00A0Svizzera<br>in mountain\u00A0bike`,
        getFlatTitle: () => `La Svizzera in mountain bike`,
        getLayerHintTitle: () => `Percorsi di La Svizzera in mountain bike`,
        categories: nationalRegionalLocalTrails,
        colorRGB: '#DEAB18',
    },
    skate: {
        legacyLandCode: 'skating',
        logoFilename: 'logos_skating_segment.geojson',
        season: 'summer',
        colorClass: 'bg-skate',
        pageColorClass: 'bg-page-skate',
        logoClass: 'bg-[url("./src/img/logo_sl.svg")]',
        landCode: 'skate',
        layer: 'skatingland',
        getTitle: () => html `La\u00A0Svizzera<br>in\u00A0skating`,
        getTitleNoHyphen: () => html `La\u00A0Svizzera<br>in\u00A0skating`,
        getFlatTitle: () => `La Svizzera in skating`,
        getLayerHintTitle: () => `Percorsi di La Svizzera in skating`,
        categories: nationalRegionalLocal,
        colorRGB: '#9D7FB7',
    },
    canoe: {
        legacyLandCode: 'kanu',
        logoFilename: 'logos_kanu_segment.geojson',
        season: 'summer',
        colorClass: 'bg-canoe',
        pageColorClass: 'bg-page-canoe',
        logoClass: 'bg-[url("./src/img/logo_kl.svg")]',
        landCode: 'canoe',
        layer: 'kanuland',
        getTitle: () => html `La\u00A0Svizzera<br>in\u00A0canoa`,
        getTitleNoHyphen: () => html `La\u00A0Svizzera<br>in\u00A0canoa`,
        getFlatTitle: () => `La Svizzera in canoa`,
        getLayerHintTitle: () => `Percorsi di La Svizzera in canoa`,
        categories: nationalRegional,
        colorRGB: '#409698',
    },
    winterhike: {
        legacyLandCode: 'winterhiking',
        logoFilename: 'logos_winterhiking_segment.geojson',
        season: 'winter',
        colorClass: 'bg-winterhike',
        pageColorClass: 'bg-page-winterhike',
        logoClass: 'bg-[url("./src/img/logo_wi_h.svg")]',
        landCode: 'winterhike',
        layer: 'winterhiking',
        getTitle: () => html `Escursioni invernali<br>`,
        getTitleNoHyphen: () => `Escursioni invernali`,
        getFlatTitle: () => `Escursioni invernali`,
        getLayerHintTitle: () => `Sentieri escursionistici invernali`,
        categories: winterCategories,
        colorRGB: '#EB6EA6',
    },
    snowshoe: {
        legacyLandCode: 'snowshoe',
        logoFilename: 'logos_snowshoe_segment.geojson',
        season: 'winter',
        colorClass: 'bg-snowshoe',
        pageColorClass: 'bg-page-snowshoe',
        logoClass: 'bg-[url("./src/img/logo_wi_s.svg")]',
        landCode: 'snowshoe',
        layer: 'snowshoe',
        getTitle: () => html `Ciaspolate<br>`,
        getTitleNoHyphen: () => html `Ciaspolate`,
        getFlatTitle: () => `Ciaspolate`,
        getLayerHintTitle: () => `Ciaspolate`,
        categories: winterCategories,
        colorRGB: '#BC5D8F',
    },
    crosscountry: {
        legacyLandCode: 'crosscountry',
        logoFilename: 'logos_crosscountry_segment.geojson',
        season: 'winter',
        colorClass: 'bg-crosscountry',
        pageColorClass: 'bg-page-crosscountry',
        logoClass: 'bg-[url("./src/img/logo_wi_c.svg")]',
        landCode: 'crosscountry',
        layer: 'crosscountry',
        getTitle: () => `Sci di\u00A0fondo`,
        getTitleNoHyphen: () => `Sci di\u00A0fondo`,
        getFlatTitle: () => `Sci di fondo`,
        getLayerHintTitle: () => `Piste di sci di fondo`,
        categories: winterCategories,
        colorRGB: '#02A7DE',
    },
    sledge: {
        legacyLandCode: 'sledging',
        logoFilename: 'logos_sledging_segment.geojson',
        season: 'winter',
        colorClass: 'bg-sledge',
        pageColorClass: 'bg-page-sledge',
        logoClass: 'bg-[url("./src/img/logo_wi_sl.svg")]',
        landCode: 'sledge',
        layer: 'sledging',
        getTitle: () => `Slittino`,
        getTitleNoHyphen: () => `Slittino`,
        getFlatTitle: () => `Slittino`,
        getLayerHintTitle: () => `Piste per slittino`,
        categories: winterCategories,
        colorRGB: '#9A6850',
    },
};
export const STATION_CODES = [
    'train',
    'bus',
    'trambus',
    'boat',
    'cableway',
    'funicular',
    'telecabin',
    'chairlift',
];
export const ACCOMMODATION_CODES = [
    'hotel',
    'bedbreakfast',
    'youthhostel',
    'backpacker',
    'groupaccom',
    'sleepingstraw',
    'farmaccom',
    'vacationapptmt',
    'mountainhut',
    'campingsite',
];
export const SERVICE_CODES = [
    'place',
    'sightseeing',
    'velorental',
    'cycleservice',
];
export const ADDITIONAL_LAYERTREE_CODES = [
    ...STATION_CODES,
    ...ACCOMMODATION_CODES,
    ...SERVICE_CODES,
    'wildlife',
    'alpguarddog',
    'slope',
    'snowdepth',
    'swisspark',
    'accommodation',
    'station',
    'slowup',
    'detour',
    'trackLayer',
    'municipalities',
    'cantons',
    'shooting',
];
export const SEASON_CODES = ['winter', 'summer'];
export const WS_ALIASES = {
    accomodation: 'accommodation',
    cycleservice: 'cycleservice',
    places: 'place',
    poi: 'sightseeing',
    rental: 'velorental',
};
export const LAND_LAYER_ORDER = [
    'hike.national',
    'hike.regional',
    'hike.local',
    'hike.handicap',
    'hike',
    'velo.national',
    'velo.regional',
    'velo.local',
    'velo',
    'mountainbike.national',
    'mountainbike.regional',
    'mountainbike.local',
    'mountainbike',
    'skate.national',
    'skate.regional',
    'skate.local',
    'skate',
    'canoe.national',
    'canoe.regional',
    'canoe.local',
    'canoe',
    'crosscountry.local',
    'crosscountry',
    'winterhike',
    'snowshoe',
    'sledge',
];
export const LAYER_ORDER = [
    'slowup',
    'station',
    ...STATION_CODES,
    'accommodation',
    ...ACCOMMODATION_CODES,
    'services',
    ...SERVICE_CODES,
    'detour',
    'shooting',
    ...LAND_LAYER_ORDER,
    'municipalities',
    'cantons',
    'slope',
    'swisspark',
    'alpguarddog',
    'wildlife',
    'wildlifearea',
    'wildlifereserve',
    'tour',
];
export const ADDITIONAL_LAYER_TYPES = [
    'accommodation',
    'velorental',
    'cycleservice',
    'bookable',
    'station',
    'swisspark',
    'slowup',
];
export const REGIONS = [
    { title: () => `Tutte`, value: 0, default: true },
    { title: () => `Argovia Regione`, value: 14 },
    { title: () => `Berna Regione`, value: 6 },
    { title: () => `Friburgo Regione`, value: 13 },
    { title: () => `Zurigo Regione`, value: 3 },
    { title: () => html `Jura &amp; Tre Laghi`, value: 8 },
    { title: () => `Ginevra Regione`, value: 10 },
    { title: () => `Lucerna - Lago di Lucerna`, value: 4 },
    { title: () => `Svizzera Orientale / Liechtenstein`, value: 2 },
    { title: () => `Regione del Lago di Ginevra`, value: 9 },
    { title: () => `Basilea Regione`, value: 5 },
    { title: () => `Grigioni`, value: 1 },
    { title: () => `Vallese`, value: 11 },
    { title: () => `Ticino`, value: 12 },
];
export const CLUSTERED_LAYER_CODES = [
    ...STATION_CODES,
    ...ACCOMMODATION_CODES,
    ...SERVICE_CODES,
];
export const OVERLAY_LAYER_CODES = [
    ...CLUSTERED_LAYER_CODES,
    'alpguarddog',
    'slope',
    'wanderwegnetz',
    'wildlife',
    'slowup',
    'swisspark',
    'crosscountrynetwork',
    'winterhikingnetwork',
    'snowshoenetwork',
    'mtbnetwork',
    'velonetwork',
    'skatenetwork',
    'mtbnetwork_surface',
    'velonetwork_surface',
    'skatenetwork_surface',
    'mtbnetwork_grade',
    'velonetwork_grade',
    'skatenetwork_grade',
    'municipalities',
    'cantons',
    'snowdepth',
];
//# sourceMappingURL=layerConstants.js.map